import { HashTabSection } from "../../components/Helpers"
import { IssueReports } from "./issue_reports_tab/IssueReports"
import { IssueReportTopics } from "./topics_tab/IssueReportTopics"

export function IssueReportsContainer() {
  return (
    <HashTabSection
      defaultTab="issueReports"
      tabItems={[
        { id: "issueReports", label: "Issue Reports" },
        { id: "topics", label: "Topics" },
      ]}
      tabContent={{
        issueReports: <IssueReports />,
        topics: <IssueReportTopics />,
      }}
    />
  )
}
